module.exports = __webpack_public_path__ + "media/images/site/junior-girl-reading-book-in-studio-7edcd0da5a1f68d6c5ae6dedecfe46aa.jpg";